import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Clock, Loader2 } from "lucide-react";
import { API } from "@/lib/site";
import { LogoMark } from "@/components/Logo";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) {
      setState("pending");
      return;
    }
    let attempts = 0;
    const timer = setInterval(async () => {
      attempts += 1;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          clearInterval(timer);
        }
      } catch (e) {
        // keep polling
      }
      if (attempts >= 15) {
        setState("pending");
        clearInterval(timer);
      }
    }, 2000);
    return () => clearInterval(timer);
  }, [sessionId]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-paper px-5" data-testid="payment-success-page">
      <div className="w-full max-w-md rounded-[32px] border border-line bg-cardx p-10 text-center shadow-xl">
        <div className="flex justify-center">
          <LogoMark size={44} />
        </div>
        {state === "checking" && (
          <>
            <Loader2 className="mx-auto mt-8 h-10 w-10 animate-spin text-brand" />
            <h1 className="mt-6 font-serif text-3xl font-semibold text-ink">Confirming your gift…</h1>
            <p className="mt-3 text-sm text-inksoft">This takes just a moment.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 className="mx-auto mt-8 h-12 w-12 text-brand" data-testid="payment-confirmed-icon" />
            <h1 className="mt-6 font-serif text-3xl font-semibold text-ink">
              Thank you. <em className="text-brand">Truly.</em>
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-inksoft">
              Your donation to The Million Hope Initiative is complete. A receipt
              from Stripe is on its way to your inbox — and your gift is already
              counted on the campaign.
            </p>
          </>
        )}
        {state === "pending" && (
          <>
            <Clock className="mx-auto mt-8 h-10 w-10 text-warm" />
            <h1 className="mt-6 font-serif text-3xl font-semibold text-ink">Almost there</h1>
            <p className="mt-3 text-sm leading-relaxed text-inksoft">
              Your payment is being confirmed. It will appear on the campaign
              total shortly — thank you for your generosity.
            </p>
          </>
        )}
        <Link
          to="/"
          data-testid="btn-back-home"
          className="mt-8 inline-block rounded-full bg-brand px-8 py-3.5 text-sm font-semibold text-[#FDFBF7] transition-colors hover:bg-branddeep"
        >
          Back to the campaign
        </Link>
      </div>
    </div>
  );
}
